var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{class:{ required: _vm.isRequired },attrs:{"label":_vm.label,"type":_vm.inputType,"message":_vm.errorMessage}},[_c('Editor',{attrs:{"api-key":'28v2bjv9q5roshia1gkxlfoglmgj1ud8h300o6byfcvtb22x',"init":{
      height: _vm.height,
      plugins: this.plugins,
      toolbar: this.toolbar,
      menubar: this.menubar,
    },"disabled":this.disabled},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }